import useTranslation from 'next-translate/useTranslation'
import { useEffect, useState } from 'react'
import { ScaleLoader } from 'react-spinners'

export interface LoadingViewProps {
  message: string
}

/** Show the real message first; start rotating the fun ones only when the
 *  request actually takes a while (grounded searches can run ~30 s). */
const FIRST_FUN_MESSAGE_AFTER_MS = 5000
const ROTATE_EVERY_MS = 4000
const FUN_MESSAGE_KEYS = [
  'loading_fun_1',
  'loading_fun_2',
  'loading_fun_3',
  'loading_fun_4',
  'loading_fun_5',
  'loading_fun_6',
] as const

export default function LoadingView({ message }: LoadingViewProps) {
  const { t } = useTranslation('wertCheck')
  const [funIndex, setFunIndex] = useState(-1)

  useEffect(() => {
    setFunIndex(-1)
    const start = setTimeout(() => setFunIndex(0), FIRST_FUN_MESSAGE_AFTER_MS)
    const rotate = setInterval(
      () =>
        setFunIndex((index) =>
          index < 0 ? index : (index + 1) % FUN_MESSAGE_KEYS.length,
        ),
      ROTATE_EVERY_MS,
    )
    return () => {
      clearTimeout(start)
      clearInterval(rotate)
    }
  }, [message])

  const text = funIndex < 0 ? message : t(FUN_MESSAGE_KEYS[funIndex])

  return (
    <div className="flex flex-col items-center gap-4 py-12">
      <ScaleLoader color="#002147" />
      <p
        key={text}
        className="text-l text-primary text-center"
        style={{ animation: 'wertcheckFadeIn 0.4s ease-in' }}
      >
        {text}
      </p>
      <style jsx global>{`
        @keyframes wertcheckFadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          p[style*='wertcheckFadeIn'] {
            animation: none !important;
          }
        }
      `}</style>
    </div>
  )
}
